import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Injectable, inject } from '@angular/core';
import * as actions from './add-tar.actions';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { AddTarResponseI } from '../../api/add-tar/add-tar.result.int';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';
import { ApiTarMethod } from 'src/app/api/api-methods.tar';
import { SpxStorage } from '@softpak/components/spx-storage';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { SharedUuidHelper } from 'src/app/shared/helpers/shared-uuid.helper';


@Injectable() 
export class AddTarEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);


  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadAddTarAction),
      mergeMap((action) => {
          if (!SpxStorage.getSetting<SharedStorageKeyEnum>(SharedStorageKeyEnum.clientGUID)) {
            SpxStorage.setSetting<SharedStorageKeyEnum>(SharedStorageKeyEnum.clientGUID, SharedUuidHelper.uuid());
          }
          // Default to original invoke method
          return this.sharedGenericService.invoke(ApiTarMethod.addTar, action.query).pipe(
            map((data: AddTarResponseI) => actions.received({ data })),
            catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
          );
      })
    ));

  onError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap(action => [
      spxToasterActions.createError({
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
        messageText: action.messageText,
      }),
    ]))
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    mergeMap((result) => (
      result.data.plOk ? [
        spxToasterActions.createSuccess({
          messageText: `Appointment ${result.data.piVBSBookingNr} added`,
          autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
        }),
      ] : [
        spxToasterActions.createError({
          messageText: `Invalid TAR or verification code`,
          autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
        }),
      ]
    ))
  )
  );
}
